import { 
  Bird, 
  User, 
  Skull, 
  Music, 
  Building2, 
  Fish, 
  Zap,
  Car, 
  Mountain, 
  Waves, 
  Leaf, // Replace Tree with Leaf
  Sword,
  Gamepad2,
  Cog
} from 'lucide-react';

export function getTimelineIcon(title: string): LucideIcon {
  if (title.includes('Tiki')) return Bird;
  if (title.includes('Lincoln')) return User;
  if (title.includes('Pirates')) return Skull;
  if (title.includes('Sings')) return Music;
  if (title.includes('EPCOT')) return Building2;
  if (title.includes('Mermaid')) return Fish;
  if (title.includes('Jurassic')) return Zap;
  if (title.includes('Track')) return Car;
  if (title.includes('Everest')) return Mountain;
  if (title.includes('River')) return Waves;
  if (title.includes('Avatar')) return Leaf; // Use Leaf instead of Tree
  if (title.includes('Star Wars')) return Sword;
  if (title.includes('WEB')) return Gamepad2;
  return Cog;
}